export default {
  init(){
    let loader;
    const form = document.getElementById('document-search-form');

    const documentList = document.getElementById('documents-list');
    const loaderEl = document.getElementById('bewi-loader-list');
    const reset = document.getElementById('filter-reset');
    // Lägg till en behållare för pagineringsknapparna i din HTML
    const paginationContainer = document.getElementById('pagination-container');
    loader = loaderEl ? loaderEl : null;
    // Händelselyssnare för ändring av checkboxar
    const checkboxes = document.querySelectorAll(
      'input[name="document_type[]"], input[name="document_cats[]"]'
    );
    checkboxes.forEach(function (checkbox) {
      checkbox.addEventListener('change', function () {
        updateDocuments(1);
      });
    });

    const sortOrderSelect = document.getElementById('sort_order');
    sortOrderSelect.addEventListener('change', function () {
      updateDocuments(1); // Starta från första sidan vid sorteringsändring
    });
    
    reset.addEventListener('click', function() {
      // Återställ filterinställningarna här
      // Återställ filterinställningarna här
      const documentTypeCheckboxes = document.querySelectorAll(
        'input[name="document_type[]"]'
      );
      const documentCatsCheckboxes = document.querySelectorAll(
        'input[name="document_cats[]"]'
      );

      // Loopa igenom och avmarkera alla dokumenttyper
      documentTypeCheckboxes.forEach(function (checkbox) {
        checkbox.checked = false;
      });

      // Loopa igenom och avmarkera alla dokumentkategorier
      documentCatsCheckboxes.forEach(function (checkbox) {
        checkbox.checked = false;
      });
      // Efter att filterinställningarna har återställts kan du uppdatera dokumenten
      updateDocuments(1);
    });

    function getLanguageFromURL() {
      const params = new URLSearchParams(window.location.search);
      return params.get('lang') || 'sv'; // Standard till 'sv' om inget språk anges
    }

    // Funktion för att uppdatera dokumenten
    function updateDocuments(page) {
      documentList.innerHTML = '';
      paginationContainer.innerHTML = '';
      loader.classList.remove('d-none');

      // Samla in data från formuläret
      const formData = new FormData(form);
      const formProps = Object.fromEntries(formData);
      formProps['document_types'] = formData.getAll('document_type[]');
      formProps['document_cats'] = formData.getAll('document_cats[]');
      formProps['page'] = page;
      formProps['sort_order'] = formData.get('sort_order');
      formProps['lang'] = getLanguageFromURL();
      // Gör en POST-förfrågan till din endpoint
      const endpoint = '/wp-json/api/fetch/filter/documents';
      fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formProps),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.html) {
            documentList.innerHTML = data.html;
          }
          loader.classList.add('d-none');
          updatePaginationButtons(data.max_num_pages, data.page);
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    }

    // Funktion för att uppdatera pagineringsknapparna
    function updatePaginationButtons(maxPages, currentPage) {
      // Ta bort befintliga pagineringsknappar
      while (paginationContainer.firstChild) {
        paginationContainer.removeChild(paginationContainer.firstChild);
      }

      // Skapa pagineringsknappar för varje sida
      for (let i = 1; i <= maxPages; i++) {
        const pageButton = document.createElement('button');
        pageButton.setAttribute('type', 'button');
        pageButton.textContent = i;
        pageButton.classList.add('pagination-button');
        if (i === currentPage) {
          pageButton.classList.add('active');
          pageButton.disabled = true;
        }
        pageButton.addEventListener('click', () => {
          updateDocuments(i); // Uppdatera dokumentlistan när en sida klickas
        });
        paginationContainer.appendChild(pageButton);
      }
    }

    // Lägg till uppdateringsfunktionen för dokumenten som en callback för formulärets submit-händelse
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      updateDocuments(1); // Starta från första sidan vid varje filtrering
    });

    // Ladda dokumentlistan för första sidan när sidan laddas
    window.addEventListener('load', function () {
      updateDocuments(1);
    });

    const downloadDocs = document.getElementById('download-docs-form');
    const downloadButton = document.getElementById('download-button');
    // Variabel för att hålla reda på om alla dokument är markerade
    let allDocumentsChecked = false;

    // Lägg till en knapp för att markera alla dokument
    const selectAllButton = document.getElementById('select-all');
    selectAllButton.addEventListener('click', function () {
      const checkboxes = document.querySelectorAll(
        'input[type="checkbox"][name="download[]"]'
      );
      checkboxes.forEach((checkbox) => {
        checkbox.checked = !allDocumentsChecked; // Växla tillståndet för att markera/avmarkera alla dokument
      });
      allDocumentsChecked = !allDocumentsChecked; // Uppdatera tillståndet för alla dokument

      // Uppdatera nedladdningsknappens tillstånd baserat på om något dokument är markerat
      updateDownloadButtonState();
    });

    // Uppdatera nedladdningsknappens tillstånd baserat på om något dokument är markerat
    function updateDownloadButtonState() {
      const checkboxes = document.querySelectorAll(
        'input[type="checkbox"][name="download[]"]'
      );
      let anyChecked = false;

      checkboxes.forEach((checkbox) => {
        if (checkbox.checked) {
          anyChecked = true;
        }
      });

      if (anyChecked) {
        downloadButton.removeAttribute('disabled');
      } else {
        downloadButton.setAttribute('disabled', 'disabled');
      }
    }

    downloadDocs.addEventListener('change', function () {
      // Uppdatera nedladdningsknappens tillstånd baserat på om något dokument är markerat
      updateDownloadButtonState();
    });

    downloadDocs.addEventListener('submit', function (event) {
      event.preventDefault();
      // Samla in data från formuläret
      const formData = new FormData(downloadDocs);
      const formProps = Object.fromEntries(formData);

      // Speciell hantering för att stödja arrayer för checkboxar med samma namn
      // Du kan behöva justera detta beroende på hur din data bör struktureras
      formProps['documents'] = formData.getAll('download[]');

      const selectedDocuments = formData.getAll('download[]');

      if (selectedDocuments.length === 0) {
        // Om inget dokument är markerat, inaktivera nedladdningsknappen
        alert('Please select at least one document to download.');
        return;
      }

      const documentsIds = selectedDocuments
        .map((id) => encodeURIComponent(id))
        .join(',');
      const endpoint = `/wp-json/api/fetch/download/documentsget/${documentsIds}`;
      // Gör en POST-förfrågan till din endpoint
      fetch(endpoint)
        .then((response) => {
          // Kontrollera content-type för att se om det är en fil
          const contentType = response.headers.get('content-type');
          if (contentType && contentType.includes('application/zip')) {
            // Hantera som en fil
            return response.blob();
          } else {
            // Antag att det är JSON om det inte är en ZIP-fil
            return response.json();
          }
        })
        .then((data) => {
          if (data instanceof Blob) {
            // Skapa en URL för blob-objektet och initiera en nedladdning
            const url = window.URL.createObjectURL(data);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'bewi-docs-download.zip';
            document.body.appendChild(a); // Krävs för Firefox
            a.click();
            window.URL.revokeObjectURL(url);
            a.remove();
          } else {
            // Hantera JSON-data
            console.log(data);
          }
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    });

    // Funktion för att hämta dokument för en specifik sida
    function fetchDocumentsForPage(page) {
      documentList.innerHTML = '';
      loader.classList.remove('d-none');

      // Samla in data från formuläret
      const formData = new FormData(form);
      const formProps = Object.fromEntries(formData);
      formProps['page'] = page; // Lägg till sidnummer i förfrågan
      formProps['lang'] = getLanguageFromURL();
      // Gör en POST-förfrågan till din endpoint med sidnummer
      const endpoint = '/wp-json/api/fetch/filter/documents';
      fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formProps),
      })
        .then((response) => response.json())
        .then((data) => {
          console.log(data); // Hantera svaret - visa dokumenten som returneras av endpointen
          if (data.html) {
            documentList.innerHTML = data.html;
          }
          loader.classList.add('d-none');
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    }

    // Funktion för att hantera klickhändelser på pagineringslänkar
    function handlePaginationClick(event) {
      event.preventDefault();
      const page = parseInt(event.target.getAttribute('data-page'));
      fetchDocumentsForPage(page);
    }

    // Lägg till händelselyssnare för klick på pagineringslänkar
    document.addEventListener('click', function (event) {
      if (event.target.matches('.pagination-link')) {
        handlePaginationClick(event);
      }
    });
  },
}


// WEBPACK FOOTER //
// ./scripts/routes/documents.js